/* Kilomia — animaciones al hacer scroll y demo día/noche. */
(function () {
  if (window.__kmInit) return;
  window.__kmInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('km-js');

  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-km-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function dayNight(root) {
    (root || document).querySelectorAll('[data-km-dn]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '1');
      var btns = box.querySelectorAll('[data-km-mode]');
      var timer = null, userTouched = false;
      function set(mode, lowered) {
        box.setAttribute('data-mode', mode);
        box.classList.toggle('is-lowered', !!lowered);
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-km-mode') === mode ? 'true' : 'false'); });
      }
      function cycle() {
        var steps = [['day', false], ['day', true], ['night', false], ['night', true]];
        var i = 0;
        set(steps[0][0], steps[0][1]);
        timer = setInterval(function () {
          if (userTouched) { clearInterval(timer); return; }
          i = (i + 1) % steps.length;
          set(steps[i][0], steps[i][1]);
        }, 2600);
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          userTouched = true; clearInterval(timer);
          set(b.getAttribute('data-km-mode'), true);
        });
      });
      var toggle = box.querySelector('[data-km-lower]');
      if (toggle) toggle.addEventListener('click', function () {
        userTouched = true; clearInterval(timer);
        box.classList.toggle('is-lowered');
      });
      if (reduce) { set('day', true); } else { cycle(); }
    });
  }

  function init(root) { reveal(root); dayNight(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
